import { ProductCheckboxList } from 'components/CheckboxList';
import {
	LoadingSkeleton,
	LoadingSkeletonItem,
} from 'components/LoadingSkeleton';
import type { VariantId } from 'models/product';

import { useAccessoriesContext } from './ProductDetailsContext';

interface Props {
	accessoryCount: number;
	className?: string;
	onSelectedAdd: (id: VariantId) => void;
	onSelectedRemove: (id: VariantId) => void;
	productId: VariantId;
	selectedIds: VariantId[];
	title: string;
}

export default function ProductDetailsAccessoriesUpsell({
	accessoryCount,
	className,
	onSelectedAdd,
	onSelectedRemove,
	productId,
	selectedIds,
	title,
}: Props) {
	const { isLoading, items } = useAccessoriesContext();

	if (isLoading) {
		return (
			<LoadingSkeleton className={className}>
				<LoadingSkeletonItem height="text" width="9rem" className="mb-2" />
				<LoadingSkeletonItem
					height={accessoryCount === 1 ? '6.5rem' : '12.5rem'}
					// For the box border.
					className="box-content py-px"
				/>
				{accessoryCount > 2 && (
					<LoadingSkeletonItem
						height="text"
						width="5rem"
						className="mx-auto mt-2 py-1"
					/>
				)}
			</LoadingSkeleton>
		);
	}

	return (
		<ProductCheckboxList
			checkedIds={selectedIds}
			className={className}
			gtmItemListId="pdp_accessories_upsale"
			gtmItemListName={`List: Accessories upsale ${productId}`}
			initialVisibleItemsCount={2}
			products={items}
			title={title}
			onItemChange={(e) => {
				const id = e.target.value;
				if (selectedIds.includes(id)) {
					onSelectedRemove(id);
				} else {
					onSelectedAdd(id);
				}
			}}
		/>
	);
}
ProductDetailsAccessoriesUpsell.displayName = 'ProductDetailsAccessoriesUpsell';
